import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import Modal from '../Modal'

export default class ModalContainer extends Component {
  static propTypes = {
    types: PropTypes.array, // Array of modalTypes that can be displayed such as : ['FILE_DOWNLOAD'] (If not supplied, all modals will be displayed)
    modal: PropTypes.object, // Modals object
  }
  render() {
    const { modal, types, ...otherProps } = this.props
    const stack = modal.stack ? modal.stack : []
    const filteredStack = types ? stack.filter(item => types.includes(item.modalType)) : stack

    return (
      <div {...otherProps}>
        {filteredStack.map(modalItem => (
          <Modal key={modalItem.modalId} modal={modalItem} />
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Modal/ModalContainer/ModalContainer.jsx